import createReducer from 'core/utils/redux';
import { types } from './actions';

export const initialState = {
	showPreloader: true,
	currentPage: 1,
	searchText: '',
	totalPages: 1,
	listNotifications: []
};

const reducer = {
	[types.GET_NOTIFICATIONS](state, { page, search }) {
		return { ...state, currentPage: page, searchText: search };
	},
	[types.SET_NOTIFICATIONS](state, { payload }) {
		return {
			...state,
			totalPages: payload.totalPages,
			listNotifications: [...state.listNotifications, ...payload.content]
		};
	},
	[types.UPDATE_NOTIFICATION_STATUS](state, { news }) {
		const listNotifications = state.listNotifications.map(
			item =>
				news
					? item.cdNotificacaoBrowser === news.cdNotificacaoBrowser
						? { ...item, status: item.status === 'OPEN' ? 'CLOSE' : 'OPEN' }
						: item
					: { ...item, status: 'OPEN' }
		);
		return { ...state, listNotifications };
	},
	[types.UPDATE_SHOW_PRELOADER](state, { bool }) {
		return {
			...state,
			showPreloader: bool
		};
	},
	[types.RESET_NOTIFICATIONS](state) {
		return { ...state, currentPage: 1, totalPages: 1, listNotifications: [] };
	}
};

export default createReducer(initialState, reducer);
